// extracted by mini-css-extract-plugin
export default {"header":"Header_header__bF0lW","notification":"Header_notification__FL2l0","pageTitle":"Header_pageTitle__Twa+v","info":"Header_info__7Gypu"};